module.exports = __webpack_public_path__ + "img/vof.597a2611.svg";